import {
  RefreshSharp
} from "@mui/icons-material";
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import { format } from "date-fns";
import * as XLSX from "xlsx";
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";

import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

function ItemLedgerComp(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [update, setUpdate] = useState(false);
  const location = useLocation();
  const { globalUser, setPageHeader, globalToken, allItems, globalStores, globalSetting } =
    useContext(ShoppingCartContext);
  var currentDate = new Date()
  const [startDate, setStartDate] = useState(format(currentDate.setDate(currentDate.getDate() - parseInt(globalSetting?.filter(gs => gs.Description === "Home Page days Range").length ? globalSetting?.filter(gs => gs.Description === "Home Page days Range")[0].Value : 30
  )), "yyyy-MM-dd"))
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"))

  const [itemtransferList, setItemTransferList] = useState([]);


  const [store, setStore] = useState('');
  const [selectedItem, setSelectedItem] = useState('');

  const [employeeList, setEmployeeList] = useState([]);
  const [storesList, setStoresList] = useState([]);

  //const { t, i18n } = useTranslation();
  const loadStoresList = () => {
    axios
      .get("/stores/getByParent?Parent=" + globalUser.Parent, {
        headers: {
          token: globalToken,
        },
      })
      .then((response) => {
        if (response.data.data) {
          setStoresList(response.data.data);
        } else {
          alert("log out and log in again");
        }
      });
  };

  const columns = useMemo(
    () => [
      {
        header: "Item",
        accessorKey: "Item",
        size: "70",
      },
      {
        header: "Item Name",
        accessorKey: "Name",
        size: "100",
      },
      {
        header: "Posting Date",
        accessorKey: "VoucherDate",
        size: "100",
      },
      {
        header: "Store",
        accessorKey: "Store",
        size: "100",
      },
      {
        header: "Type",
        accessorKey: "Status",
        size: "50",
      },
      {
        header: "Qty",
        accessorKey: "Quantity",
        size: "60",
      },

      {
        header: "Price",
        accessorKey: "TotalPrice",
        size: "60",
      },
      {
        header: "Cost",
        accessorKey: "CalculatedCost",
        size: "60",
      },
      {
        header: "Inventory",
        accessorKey: "Balance",
        size: "100",
      },
      {
        header: "Reference",
        accessorKey: "OrderId",
        size: "80",
      },

    ],
    []
  );

  const loadItemLedgerList = () => {

    axios
      .get(
        "/lineItems/getItemLedger?Parent=" +
        globalUser.Parent +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate +
        "&Store=" + (storesList.filter((it) => it.Name == store).length > 0
          ? storesList.filter((it) => it.Name == store)[0]
            .Id
          : 0) +
        "&Item=" + (allItems.filter((it) => it.Name == selectedItem).length > 0
          ? allItems.filter((it) => it.Name == selectedItem)[0]
            .Item
          : 0),
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {
        if (response.data.data) {
          setItemTransferList(response.data.data);
        } else {
          alert("log out and log in again");
        }
      });
  };
  const loadEmployeeList = () => {
    axios
      .get("/employees/getByParent?Parent=" + globalUser.Parent, {
        headers: {
          token: globalToken,
        },
      })
      .then((response) => {
        if (response.data.data) {
          setEmployeeList(response.data.data);
        } else {
          alert("log out and log in again");
        }
      });
  };
  const handleUploadFile = async (e) => {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    var jsonData = XLSX.utils.sheet_to_json(worksheet);

    var fdata = new FormData();
    fdata.append("JsonData", JSON.stringify(jsonData));
    await axios.post("/itemtransfers/Excel", fdata, {
      headers: { "Content-Type": "application/json", token: globalToken },
    });
  };
  function handleDownloadFile() {
    const worksheet = XLSX.utils.json_to_sheet(itemtransferList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "itemtransfers");
    //let buf = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "itemtransfersdata.xlsx");
  }

  useEffect(() => {
    if (!globalUser) {
      navigate("/");
      return;
    }
    loadStoresList();

    setPageHeader("Item Ledger");
    loadEmployeeList();
    loadItemLedgerList();
  }, [update, store, selectedItem, startDate, endDate]);

  return (
    <div width="100%">
      {storesList !== undefined &&
        storesList !== null &&
        storesList.length &&
        employeeList !== undefined &&
        employeeList !== null &&
        employeeList.length > 0 ? (
        <Grid container>
          <Grid item xs={12} mt={1}>

            <Box sx={{ direction: 'column', display: 'flex', flex: 1 }}>
              <Autocomplete
                disablePortal
                selectOnFocus
                autoHighlight
                contentEditable={false}
                value={selectedItem}
                id="Type"
                /* onSelectCapture={(e) => {
                  setSelectedPurchaseType(e.target.value);
                }} */
                onChange={(event, newValue) => {
                  setSelectedItem(newValue); // ✅ updates state
                }}
                options={
                  allItems ?
                    allItems.map((item) =>
                      item.Name
                    ) : ['']
                }
                sx={{
                  flex: 1,
                  marginLeft: 5,
                  marginBottom: 2,
                  borderRadius: "25%",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Item"
                    variant="standard"
                  //error={!fromAirport ? true : false}
                  />
                )}
              />
              <Autocomplete
                disablePortal
                selectOnFocus
                autoHighlight
                contentEditable={false}
                value={store}
                id="Type"
                /* onSelectCapture={(e) => {
                  setSelectedPurchaseType(e.target.value);
                }} */
                onChange={(event, newValue) => {
                  setStore(newValue); // ✅ updates state
                }}
                options={
                  globalStores ?
                    globalStores.map((item) =>
                      item.Name
                    ) : ['']
                }
                sx={{
                  flex: 1,
                  marginBottom: 2,
                  marginLeft: 5,
                  borderRadius: "25%",
                  color: theme.palette.primary.contrastText
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Store"
                    variant="standard"
                  //error={!fromAirport ? true : false}
                  />
                )}
              />
              <TextField
                size="small"
                type='date'
                variant="standard"
                label={"Start Date"}
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
                sx={{ color: theme.palette.primary.contrastText }}

                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: theme.palette.primary.contrastText,
                  },
                }}
                InputProps={{
                  shrink: true,
                  sx: {
                    color: theme.palette.primary.contrastText,
                  },
                }}
              />
              <TextField
                size="small"
                type='date'
                variant="standard"
                label={"End Date"}
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                sx={{ color: theme.palette.primary.contrastText }}

                InputLabelProps={{
                  shrink: true,
                  sx: {
                    color: theme.palette.primary.contrastText,
                  },
                }}
                InputProps={{
                  shrink: true,
                  sx: {
                    color: theme.palette.primary.contrastText,
                  },
                }}
              />
            </Box>

          </Grid>
          <Grid item className="hideInMobile" m={1}>

            <MaterialReactTable
              columns={columns}
              data={itemtransferList}
              initialState={{
                density: "compact",
                pagination: {
                  pageIndex: 0,
                  pageSize: 20,
                },
              }}
              enableGlobalFilter
              // enableColumnOrdering

              enableColumnResizing
              enableRowNumbers

              muiTopToolbarProps={{
                sx: {
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                },
              }}
              renderTopToolbarCustomActions={() => (
                <Box>

                  <Button
                    size="small"
                    variant="standard"
                    sx={{ borderRadius: "30px" }}
                    endIcon={
                      <RefreshSharp
                        style={{ width: "20px", height: "20px" }}
                      />
                    }
                    onClick={() => setUpdate(!update)}
                  >
                    Refresh
                  </Button>
                </Box>
              )}
            //enableRowActions

            ></MaterialReactTable>

          </Grid>
          <Grid item xs={12} mt={1} className="hideInFull">
            {/*  <Box
              sx={{
                width: "100%",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
              }}
            >
              {location.state.Status === "Request" &&
                globalRoleSecurity.filter(
                  (gs) =>
                    gs.Functionality === "Transfer Request" && gs.Security > 2
                ).length > 0 && (
                  <>
                    <Button
                      size="small"
                      variant="standard"
                      sx={{ borderRadius: "30px" }}
                      endIcon={
                        <AddSharp style={{ width: "20px", height: "20px" }} />
                      }
                    >
                      <ItemTransferModel
                        icon={
                          <div>
                            <EditSharp
                              style={{
                                width: "10px",
                                height: "10px",
                                margin: 1,
                              }}
                            />
                            Add
                          </div>
                        }
                        StoresList={storesList}
                        TransferOrder={{
                          Id: 0,
                          Status: "Draft",
                          RequestedBy: globalUser.Id,
                          RequestedByName: globalUser.Name,
                          OrderDate: format(new Date(), "yyyy-MM-dd"),
                          FromStoreName: "",
                          ToStoreName: "",
                        }}
                        ItemTransferLines={[{}]}
                        setParentUpdate={setUpdate}
                        ParentUpdate={update}
                      />
                    </Button>
                    |
                  </>
                )}
              <Button
                size="small"
                variant="standard"
                sx={{ borderRadius: "30px" }}
                endIcon={
                  <FileDownload style={{ width: "20px", height: "20px" }} />
                }
                type="file"
                onClick={handleDownloadFile}
              >
                Download
              </Button>
              |
              <Tooltip title="refresh">
                <Button
                  size="small"
                  variant="standard"
                  sx={{ borderRadius: "30px" }}
                  endIcon={<RefreshSharp />}
                  onClick={() => setUpdate(!update)}
                >
                  Refresh
                </Button>
              </Tooltip>
            </Box> */}
          </Grid>
          {!(itemtransferList === undefined) &&
            itemtransferList.length > 0 &&
            itemtransferList.map((item) => {
              return (
                <Grid item key={item.Id} xs={12} m={2} className="hideInFull">
                  <Card sx={{ borderRadius: 10, boxShadow: 3, width: "100%" }}>
                    <CardHeader
                      avatar={
                        <Avatar
                          src={
                            item.Picture != null && item.Picture.length > 0
                              ? item.Picture.split(",")[0]
                              : "/Images/Products/default.png"
                          }
                        />
                      }
                      className="CardHeader"
                      title={item.FromStoreName} //.substring(0, 20)}
                      subheader={item.ToStoreName}
                    />

                    <CardContent>
                      <Typography variant="body2" align="left">
                        Requested By: {item.RequestedByName}
                      </Typography>
                      <Typography variant="body2" align="left">
                        Requested Date: {item.RequestedDate}
                      </Typography>
                      <Typography variant="body2" align="left">
                        Approved By: {item.ApprovedByName}
                      </Typography>
                      <Typography variant="body2" align="left">
                        Approved Date: {item.ApprovedDate}
                      </Typography>
                      <Typography variant="body2" align="left">
                        Issued By: {item.IssuedByName}
                      </Typography>
                      <Typography variant="body2" align="left">
                        Issued Date: {item.IssuedDate}
                      </Typography>
                    </CardContent>
                    {/*  <CardActions
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                      }}
                    >
                      <Stack direction="row">
                        <Tooltip title="Transfer Order">
                          <IconButton>
                            {(item.Status == "Request" ||
                              item.Status === "Approved") &&
                            globalRoleSecurity.filter(
                              (gs) =>
                                (
                                  gs.Functionality ===
                                    "Transfer " + location.state.Status &&
                                  gs.Security > 1
                                ).length > 0
                            ) ? (
                              <ItemTransferModel
                                icon={
                                  <div>
                                    <EditSharp
                                      style={{
                                        width: "13px",
                                        height: "13px",
                                        margin: 1,
                                        marginRight: 4,
                                      }}
                                    />
                                    |
                                  </div>
                                }
                                StoresList={storesList}
                                TransferOrder={item}
                                ItemTransferLines={itemTransferLineList.filter(
                                  (li) => li.Order === item.Id
                                )}
                                setParentUpdate={setUpdate}
                                ParentUpdate={update}
                              />
                            ) : (
                              <ItemTransferModelHistory
                                icon={
                                  <div>
                                    <EditSharp
                                      style={{
                                        width: "13px",
                                        height: "13px",
                                        margin: 1,
                                        marginRight: 4,
                                      }}
                                    />
                                    |
                                  </div>
                                }
                                StoresList={storesList}
                                TransferOrder={item}
                                ItemTransferLines={itemTransferLineList.filter(
                                  (li) => li.Order === item.Id
                                )}
                                setParentUpdate={setUpdate}
                                ParentUpdate={update}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        {item.Status == "Approved" &&
                          globalRoleSecurity.filter(
                            (gs) =>
                              gs.Functionality === "Transfer Issue" &&
                              gs.Security > 1
                          ).length > 0 && (
                            <Tooltip title="Transfer Issue">
                              <IconButton>
                                <ItemTransferIssueModel
                                  icon={
                                    <div>
                                      <EditSharp
                                        style={{
                                          width: "13px",
                                          height: "13px",
                                          margin: 1,
                                          marginRight: 4,
                                        }}
                                      />
                                      |
                                    </div>
                                  }
                                  StoresList={storesList}
                                  TransferOrder={item}
                                  ItemTransferLines={itemTransferLineList.filter(
                                    (li) => li.Order === item.Id
                                  )}
                                  ItemTransferIssuedLines={itemTransferIssuedLines.filter(
                                    (li) =>
                                      parseInt(li.ParentOrder) ===
                                      parseInt(item.Id)
                                  )}
                                  setParentUpdate={setUpdate}
                                  ParentUpdate={update}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        {item.Status == "Issued" &&
                          globalRoleSecurity.filter(
                            (gs) =>
                              gs.Functionality === "Transfer Receipt" &&
                              gs.Security > 1
                          ).length > 0 && (
                            <Tooltip title="Transfer Receipt">
                              <IconButton>
                                <ItemTransferIssueModel
                                  icon={
                                    <div>
                                      <EditSharp
                                        style={{
                                          width: "13px",
                                          height: "13px",
                                          margin: 1,
                                          marginRight: 4,
                                        }}
                                      />
                                      |
                                    </div>
                                  }
                                  StoresList={storesList}
                                  TransferOrder={item}
                                  ItemTransferLines={itemTransferLineList.filter(
                                    (li) => li.Order === item.Id
                                  )}
                                  ItemTransferIssuedLines={itemTransferIssuedLines.filter(
                                    (li) =>
                                      parseInt(li.ParentOrder) ===
                                      parseInt(item.Id)
                                  )}
                                  setParentUpdate={setUpdate}
                                  ParentUpdate={update}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        <Tooltip title="Transfer Preview">
                          <IconButton>
                            <InvoicePreview
                              icon={
                                <div>
                                  <PreviewSharp
                                    style={{
                                      width: "13px",
                                      height: "13px",
                                      margin: 1,
                                      marginRight: 4,
                                    }}
                                  />
                                  |
                                </div>
                              }
                              data={[item]}
                              LineItems={itemTransferLineList.filter(
                                (ijl) =>
                                  parseInt(ijl.Order) === parseInt(item.Id)
                              )}
                              Type="TransferOrder"
                              DocumentType={"Tansfer " + location.state.Status}
                            />
                          </IconButton>
                        </Tooltip>
                        ,
                      </Stack>
                    </CardActions> */}
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      ) : (
        <div>There is not employee in this company</div>
      )}
    </div>
  );
}

export default ItemLedgerComp;
